/* eslint-disable no-unused-vars */
import ApiService from "../api.service";
import appConfig from "../../../app-config";
import { TokenStorage } from "../../storage";
import SalesFormulas from "../../../_helpers/formulas/sales-formulas";

import { getFactorByCode } from "../../../_store/helpers";

const {
  calculateStockUMQty,
  calculateDiscLineTotal,
  calculateNetLineTotal,
  calculateWetLineTotal,
  calculateTaxableLineTotal,
  calculateTaxLineTotal,
  calculateLineTotal,
  calculateDiscFXLineTotal,
  calculateNetFXLineTotal,
  calculateWetFXLineTotal,
  calculateTaxableFXLineTotal,
  calculateTaxFXLineTotal,
  calculateFXLineTotal,
} = SalesFormulas;

ApiService.init(appConfig.VUE_APP_ROOT_API);

const SalesOrderService = {
  /**
   * Get Screen data
   *
   * */
  async getByCode(code, params) {
    const requestScreenData = {
      url: "api/SalesOrder",
      filter: `Code eq ${code} &$expand=Company($select=Code,CurrencyCode),Customer($select=Name,StopCredit,TermCalculation),SalesOrderType($select=Code,Description),Branch($select=Code,Description),Division($select=Code,Description),SalesRepresentative($select=Code,FirstName,Surname)`,
    };

    if (params) {
      if (params.select) {
        requestScreenData.select = params.select;
      }
    }

    return await ApiService.oDataGet(requestScreenData);
  },
  async getActiveByCode(code) {
    const requestScreenData = {
      url: "api/SalesOrder",
      top: "1",
      filter: `CustomerCode eq '${code}' and Status eq 'A'`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },
  async findOrderNoUsageForSalesOrder(orderNo, soCode, customerCode) {
    let filterString = "";

    if (soCode) {
      filterString = `tolower(OrderNo) eq tolower('${orderNo}') and CustomerCode eq '${customerCode}' and Code ne ${soCode}`;
    } else {
      filterString = `tolower(OrderNo) eq tolower('${orderNo}') and CustomerCode eq '${customerCode}'`;
    }
    const requestScreenData = {
      url: "api/SalesOrder",
      top: "1",
      filter: filterString,
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async findOrderNoUsageForInvoice(orderNo, soCode, customerCode) {
    let filterString = "";

    if (soCode) {
      filterString = `tolower(OrderNo) eq tolower('${orderNo}') and CustomerCode eq '${customerCode}' and Code ne ${soCode}`;
    } else {
      filterString = `tolower(OrderNo) eq tolower('${orderNo}') and CustomerCode eq '${customerCode}'`;
    }
    const requestScreenData = {
      url: "api/Invoice",
      top: "1",
      filter: filterString,
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  dataSourceConfig(url, params) {
    return ApiService.createDataSource(url, params);
  },

  async cancelSalesOrder(payload) {
    var url = "api/Save_SalesOrderCancel";
    return await ApiService.post(url, payload);
  },

  async saveSalesOrder(payload, orderId) {
    var url = orderId > 0 ? `api/Save_SalesOrder` : `api/Save_SalesOrder`;

    if (orderId > 0) {
      return await ApiService.put(url, orderId, payload, "Integer");
    } else {
      return await ApiService.post(url, payload);
    }
  },
  async saveSalesOrderMultiple(payload) {
    return await ApiService.post(`api/Save_SalesOrderMultiple`, payload);
  },
  async adjustShipDate(payLoad) {
    return await ApiService.post(`api/Save_SalesOrderAdjustShipDate`, payLoad);
  },
  async completeSalesOrder(payLoad) {
    return await ApiService.post(`api/Save_CompleteSalesOrder`, payLoad);
  },
  accountStatusDataSourceConfig(params) {
    var url = "api/CustomerAging";
    return ApiService.createDataSource(url, params);
  },

  getTotalBalance(params) {
    params.url = "api/CustomerAging";
    return ApiService.oDataGet(params);
  },

  async getSaleItemPrice(params) {
    var url = "api/SaleItemPrice?TransactionDate={TransactionDate}&SalesOrderTypeCode={SalesOrderTypeCode}&ItemType={ItemType}&BranchCode={BranchCode}&CustomerCode={CustomerCode}&ItemCode={ItemCode}&SalesUM={SalesUM}&SalesUMQty={SalesUMQty}&ExchangeRate={ExchangeRate}"
      .replace("{TransactionDate}", params.TransactionDate)
      .replace("{SalesOrderTypeCode}", params.SalesOrderTypeCode)
      .replace("{ItemType}", params.ItemType)
      .replace("{BranchCode}", params.BranchCode)
      .replace("{CustomerCode}", params.CustomerCode)
      .replace("{ItemCode}", params.ItemCode)
      .replace("{SalesUM}", params.SalesUM)
      .replace("{SalesUMQty}", params.SalesUMQty)
      .replace("{ExchangeRate}", params.ExchangeRate);
    return await ApiService.get(url);
  },

  async setSaleItemPrice(
    record,
    soTypeCode,
    branchCode,
    customerCode,
    exchangeRate,
    dateIn,
    reqdByDate,
    calculateComputedFields
  ) {
    var tranDate = dateIn; // window.ViewModel.Screen.DateIn();

    let requiredByFactor = getFactorByCode(616);
    // eslint-disable-next-line no-console
    // this.$logger.debug("requiredByFactor", requiredByFactor);
    if (
      requiredByFactor &&
      requiredByFactor.Factorc.toUpperCase() === "REQUIRED BY"
    ) {
      tranDate = reqdByDate;
    }

    tranDate = tranDate.toShortDateString();

    var requestData = {
      TransactionDate: tranDate,
      SalesOrderTypeCode: soTypeCode,
      BranchCode: branchCode,
      CustomerCode: customerCode,
      ExchangeRate: exchangeRate,
      ItemType: record.ItemType,
      ItemCode: record.ItemCode,
      SalesUM: record.SalesUM,
      SalesUMQty: record.SalesUMQty,
    };

    // eslint-disable-next-line no-console
    // this.$logger.debug("getSaleItemPrice REQUEST: " + JSON.stringify(requestData));
    // window.ViewModel.CommonHelper.logMessage(
    //   "getSaleItemPrice REQUEST: " + JSON.stringify(requestData)
    // );

    return await this.getSaleItemPrice(requestData)
      .then((res) => {
        let data = res.data;
        // eslint-disable-next-line no-console
        // this.$logger.debug("getSaleItemPrice RESPONSE: " + JSON.stringify(data));
        // window.ViewModel.CommonHelper.logMessage(
        //   "getSaleItemPrice RESPONSE: " + JSON.stringify(data)
        // );

        record.AddDiscPriceGroupCode = data.AddDiscPriceGroupCode || 0;
        record.AddDiscPricingMethod = data.AddDiscPricingMethod || "";
        record.AddDiscPricingMethodValue = data.AddDiscPricingMethodValue || 0;
        record.AddDiscSalesUMPrice = data.AddDiscSalesUMPrice;
        record.AddDiscStockUMPrice = data.AddDiscStockUMPrice;
        record.CalculatedDiscPcnt = data.CalculatedDiscPcnt;
        record.DiscPcnt = data.DiscPcnt;
        record.IsPrimeCostItem = data.IsPrimeCostItem;
        record.PriceGroupCode = data.PriceGroupCode;
        record.PriceGroupSalesUMPrice = data.PriceGroupSalesUMPrice;
        record.PriceGroupStockUMPrice = data.PriceGroupStockUMPrice;
        record.PricingMethod = data.PricingMethod;
        record.PricingMethodValue = data.PricingMethodValue || 0;
        record.SalesTaxPcnt = data.SalesTaxPcnt;
        record.SalesUMConversion = data.SalesUMConversion;
        record.SalesUMCost = data.SalesUMStandardCost;
        record.StockUMStandardCost = data.StockUMStandardCost;
        record.ExTaxUnitCost = data.StockUMStandardCost;
        record.SalesUMFXPrice = data.SalesUMFXPrice;
        record.SalesUMIsVariable = data.SalesUMIsVariable;
        record.SalesUMManufacturedCost = (
          data.StockUMStandardCost * data.SalesUMConversion
        ).roundNumber(4);
        record.SalesUMQty !== 0
          ? (record.SalesUMNetFXPrice = data.SalesUMNetFXPrice)
          : (record.SalesUMNetFXPrice = 0);
        record.SalesUMNetPrice = data.SalesUMNetPrice;
        record.SalesUMPrice = data.SalesUMPrice;
        record.SalesUMPromotionNetPrice = data.SalesUMPromotionNetPrice;
        record.SalesUMStandardCost = data.SalesUMStandardCost;
        record.SalesUMStandardPrice = data.SalesUMStandardPrice;
        record.StockUM = data.StockUM;
        record.StockUM = data.StockUM;
        record.StockUMFXPrice = data.StockUMFXPrice;
        record.StockUMManufacturedCost = data.StockUMStandardCost;
        record.StockUMNetFXPrice = data.StockUMNetFXPrice;
        record.StockUMNetPrice = data.StockUMNetPrice;
        record.StockUMPrice = data.StockUMPrice;
        record.StockUMQty = calculateStockUMQty(
          record.SalesUMQty,
          record.SalesUMConversion
        );
        record.StockUMStandardPrice = data.StockUMStandardPrice;
        record.TaxCode = data.TaxCode;
        record.WetPcnt = data.WetPcnt;

        // FX Totals
        record.DiscFXLineTotal = calculateDiscFXLineTotal(
          record.SalesUMFXPrice,
          record.SalesUMNetFXPrice,
          record.SalesUMQty
        );
        record.NetFXLineTotal = calculateNetFXLineTotal(
          record.SalesUMNetFXPrice,
          record.SalesUMQty
        );

        record.WetFXLineTotal = calculateWetFXLineTotal(
          record.NetFXLineTotal,
          record.WetPcnt
        );

        record.TaxableFXLineTotal = calculateTaxableFXLineTotal(
          record.NetFXLineTotal,
          record.WetFXLineTotal
        );
        record.TaxFXLineTotal = calculateTaxFXLineTotal(
          record.NetFXLineTotal,
          record.WetFXLineTotal,
          record.SalesTaxPcnt
        );
        record.FXLineTotal = calculateFXLineTotal(
          record.TaxableFXLineTotal,
          record.TaxFXLineTotal
        );

        // Totals
        record.DiscLineTotal = calculateDiscLineTotal(
          record.DiscFXLineTotal,
          exchangeRate
        );
        record.NetLineTotal = calculateNetLineTotal(
          record.NetFXLineTotal,
          exchangeRate
        );
        record.WetLineTotal = calculateWetLineTotal(
          record.WetFXLineTotal,
          exchangeRate
        );
        record.TaxableLineTotal = calculateTaxableLineTotal(
          record.TaxableFXLineTotal,
          exchangeRate
        );
        record.TaxLineTotal = calculateTaxLineTotal(
          record.TaxFXLineTotal,
          exchangeRate
        );
        record.LineTotal = calculateLineTotal(record.FXLineTotal, exchangeRate);

        // if (calculateComputedFields) {
        //   window.ViewModel.calculateComputedFields();
        // }

        // record.refreshTemplateForColumn("ItemCode");
      })
      .catch((error) => {
        // eslint-disable-next-line no-console
        // this.$logger.debug("setSalesItemPrice ERROR", error);
        // if (calculateComputedFields) {
        //   window.ViewModel.calculateComputedFields();
        // }
      });
  },
  async getSalesOrderPromotion(filter) {
    const requestScreenData = {
      url: "api/SaleItemPromotion",
      orderBy: "ItemCode",
      // top: 1,
      // expand: "Product($select=PackSize,APN)",
      filter: filter,
    };
    return await ApiService.oDataGet(requestScreenData);
  },
  async getSalesPromotionItems(filter, select) {
    const requestScreenData = {
      url: "api/SaleItemPromotion",
      orderBy: "ItemCode",
      filter: filter,
      select: select,
    };
    return await ApiService.oDataGet(requestScreenData);
  },

  async getProductStock(filter) {
    const requestScreenData = {
      url: "api/ProductStock",
      filter: filter,
    };
    return await ApiService.oDataGet(requestScreenData);
  },

  async getSaleItemCompanyBranchProduct(itemCode, branchCode) {
    const requestData = {
      url: "api/SaleItemCompanyBranch",
      filter: `ItemCode eq '${itemCode}' and ItemType eq 'S' and IsDefault eq 'Y' and BranchCode eq '${branchCode}' and AvailableForSale eq 'Y'`,
    };
    return await ApiService.oDataGet(requestData);
  },

  async getSoGridColumn(filterCode) {
    const requestData = {
      url: "api/OrderGridColumn",
      orderBy: "Sequence",
      filter: `FilterCode eq '${filterCode}'`,
    };
    return await ApiService.oDataGet(requestData);
  },

  async getSalesOrderBalanceByCode(salesOrderCode) {
    const requestData = {
      url: `SalesOrderBalance/${salesOrderCode}`,
    };
    let salesOrderBalanceRequestData = await ApiService.oDataGet(requestData);
    return {
      PaidAmount: salesOrderBalanceRequestData.data.PaidAmount,
      SalesOrderCode: salesOrderBalanceRequestData.data.SalesOrderCode,
      SalesOrderTotal: salesOrderBalanceRequestData.data.SalesOrderTotal,
    };
  },
  async partPickSalesOrder(payLoad) {
    return await ApiService.post(
      `api/Save_ConsolidatedMaterialPickingSlip`,
      payLoad
    );
  },
  async getConsolidatedSalesOrderMaterialBySalesOrderCode(salesOrderCode) {
    const requestData = {
      url: `api/ConsolidatedSalesOrderMaterials`,
      filter: `SalesOrderCode eq ${salesOrderCode}`,
    };
    return await ApiService.oDataGet(requestData);
  },


  async getSalesOrderItem(params) {
    const requestScreenData = {
      url: "api/SalesOrder",
      top: 1,
      filter: params.filter,
      select: params.select
    };
    return await ApiService.oDataGet(requestScreenData);
  },
};

export { SalesOrderService };
